<div class="ui segment"  appMargin marginB="3" fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start stretch" >
	<!-- <div fxFlex="5%">
		   <sui-checkbox >
            </sui-checkbox>
	</div> -->
		<div fxFlex="25%">{{template?.name}}</div>
		<div fxFlex>{{template?.description}}</div>
		<div fxFlex  class="text-right">
			<button
				class="ui circular tiny button"
				(click)="onDelete.emit(template)"
				suiPopup
				[popupInverted]="true"
				popupPlacement="bottom"
				popupText="Delete"
			>
				<i class="trash icon"></i>
			</button>
			<a
				class="ui circular tiny button"
				routerLink="/admin/setting/document-template/detail/{{template.id}}"
				suiPopup
				[popupInverted]="true"
				popupPlacement="bottom"
				popupText="View"
			>
				<i class="eye icon"></i>
			</a>
		</div>
</div>